export const initiatePaytmTransaction = async ({ apiBase = '', token, orderId }) => {
  const res = await fetch(`${apiBase}/api/paytm/initiate`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    },
    body: JSON.stringify({ orderId })
  });

  const json = await res.json().catch(() => null);
  if (!res.ok || !json?.success) {
    throw new Error(json?.message || 'Failed to initiate Paytm transaction');
  }

  return json.data;
};

export const submitPaytmPaymentForm = ({ paytmBaseUrl, mid, orderId, txnToken }) => {
  // Paytm showPaymentPage expects a POST with txnToken.
  const action = `${paytmBaseUrl}/theia/api/v1/showPaymentPage?mid=${encodeURIComponent(mid)}&orderId=${encodeURIComponent(orderId)}`;

  const form = document.createElement('form');
  form.method = 'POST';
  form.action = action;

  const tokenInput = document.createElement('input');
  tokenInput.type = 'hidden';
  tokenInput.name = 'txnToken';
  tokenInput.value = txnToken;
  form.appendChild(tokenInput);

  document.body.appendChild(form);
  form.submit();
};
